import React from 'react'
import EnterAccountPasswordModal from '../../components/modals/enter-account-password'
import { usePasswordValidation } from '../../hooks/usePasswordValidation'

const EnterAccountPasswordWrapper = ({ children }) => {
  const isPasswordValid = usePasswordValidation()

  if (!isPasswordValid) {
    return <EnterAccountPasswordModal />
  }

  return <>{children}</>
}

export default EnterAccountPasswordWrapper
